var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4451 8.19828C24.4451 7.10429 24.4451 6.55729 24.1052 6.21742C23.7653 5.87756 23.2183 5.87756 22.1243 5.87756C21.0304 5.87756 20.4834 5.87756 20.1435 6.21742C19.8036 6.55729 19.8036 7.10429 19.8036 8.19828V10.519C19.8036 11.613 19.8036 12.16 20.1435 12.4999C20.4834 12.8397 21.0304 12.8397 22.1243 12.8397C23.2183 12.8397 23.7653 12.8397 24.1052 12.4999C24.4451 12.16 24.4451 11.613 24.4451 10.519V8.19828Z",
    fill: "url(#paint0_linear_5178_10910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 20.6224C16.3226 20.2825 16.3226 19.7355 16.3226 18.6415V9.35864C16.3226 8.26464 16.3226 7.71765 15.9827 7.37778C15.6428 7.03792 15.0958 7.03792 14.0018 7.03792C12.9078 7.03792 12.3608 7.03792 12.021 7.37778C11.6811 7.71765 11.6811 8.26464 11.6811 9.35864V18.6415C11.6811 19.7355 11.6811 20.2825 12.021 20.6224C12.3608 20.9622 12.9078 20.9622 14.0018 20.9622C15.0958 20.9622 15.6428 20.9622 15.9827 20.6224Z",
    fill: "url(#paint1_linear_5178_10910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20003 14.0001V16.3208C8.20003 17.4148 8.20003 17.9618 7.86017 18.3017C7.52031 18.6415 6.97331 18.6415 5.87931 18.6415C4.78532 18.6415 4.23832 18.6415 3.89846 18.3017C3.55859 17.9618 3.55859 17.4148 3.55859 16.3208V14.0001C3.55859 12.9061 3.55859 12.3591 3.89846 12.0192C4.23832 11.6794 4.78532 11.6794 5.87931 11.6794C6.97331 11.6794 7.52031 11.6794 7.86017 12.0192C8.20003 12.3591 8.20003 12.9061 8.20003 14.0001Z",
    fill: "url(#paint2_linear_5178_10910)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1307 6.17776V3.55679C13.1307 3.0764 13.5206 2.68652 14.001 2.68652C14.4814 2.68652 14.8713 3.0764 14.8713 3.55679V6.17776C15.6199 6.20687 16.1467 6.31944 16.5932 6.75475L16.6037 6.76518C17.192 7.35928 17.192 8.11121 17.192 9.35859V18.6415C17.192 19.8877 17.192 20.6396 16.6037 21.2349L16.5932 21.2453C16.1467 21.6806 15.6199 21.7932 14.8713 21.8223V24.4433C14.8713 24.9237 14.4814 25.3135 14.001 25.3135C13.5206 25.3135 13.1307 24.9237 13.1307 24.4433V21.8223C12.3821 21.7932 11.8553 21.6806 11.4088 21.2453L11.3984 21.2349C10.8101 20.6408 10.81 19.8889 10.81 18.6415V9.35859C10.81 8.11237 10.8101 7.36044 11.3984 6.76518L11.4088 6.75475C11.8553 6.31944 12.3821 6.20687 13.1307 6.17776ZM12.6329 7.99404C12.7536 7.90817 13.444 7.90814 14.001 7.90814C14.558 7.90814 15.2484 7.90817 15.3691 7.99404C15.4515 8.12979 15.4515 8.78182 15.4515 9.3585V18.6415C15.4515 19.2181 15.4515 19.8714 15.3691 20.006C15.2484 20.0919 14.558 20.0919 14.001 20.0919C13.444 20.0919 12.7536 20.0919 12.6329 20.006C12.5506 19.8703 12.5506 19.2182 12.5506 18.6416V9.35859C12.5506 8.78192 12.5506 8.12863 12.6329 7.99404Z",
    fill: "url(#paint3_linear_5178_10910)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2533 13.6998C20.5046 13.6707 19.9778 13.5581 19.5313 13.1228L19.5209 13.1124C18.9326 12.5183 18.9325 11.7663 18.9325 10.519V8.19823C18.9325 6.95201 18.9326 6.20008 19.5209 5.60482L19.5313 5.59439C19.9778 5.15908 20.5046 5.04651 21.2533 5.0174V3.55679C21.2533 3.0764 21.6431 2.68652 22.1235 2.68652C22.6039 2.68652 22.9938 3.0764 22.9938 3.55679V5.0174C23.7424 5.04651 24.2693 5.15908 24.7158 5.59439L24.7262 5.60482C25.3145 6.19892 25.3145 6.95085 25.3145 8.19823V10.519C25.3145 11.7652 25.3145 12.5171 24.7262 13.1124L24.7158 13.1228C24.2693 13.5581 23.7424 13.6707 22.9938 13.6998V15.1604C22.9938 15.6408 22.6039 16.0307 22.1235 16.0307C21.6431 16.0307 21.2533 15.6408 21.2533 15.1604V13.6998ZM22.1235 6.74778C21.5666 6.74778 20.8761 6.74781 20.7555 6.83368C20.6731 6.96827 20.6731 7.62146 20.6731 8.19814V10.519C20.6731 11.0956 20.6731 11.7478 20.7555 11.8835C20.8761 11.9694 21.5666 11.9694 22.1235 11.9694C22.6805 11.9694 23.3709 11.9694 23.4916 11.8835C23.574 11.7489 23.574 11.0957 23.574 10.519V8.19823C23.574 7.62156 23.574 6.96943 23.4916 6.83368C23.3709 6.74781 22.6805 6.74778 22.1235 6.74778Z",
    fill: "url(#paint4_linear_5178_10910)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28626 18.9246C3.73276 19.3599 4.25961 19.4725 5.00822 19.5016V20.9622C5.00822 21.4426 5.3981 21.8325 5.87849 21.8325C6.35888 21.8325 6.74876 21.4426 6.74876 20.9622V19.5016C7.49737 19.4725 8.02422 19.3599 8.47072 18.9246L8.48114 18.9142C9.06944 18.3189 9.06948 17.567 9.06948 16.3208V14C9.06948 12.7526 9.06944 12.0007 8.48114 11.4066L8.47072 11.3962C8.02422 10.9609 7.49737 10.8483 6.74876 10.8192V9.35859C6.74876 8.8782 6.35888 8.48832 5.87849 8.48832C5.3981 8.48832 5.00822 8.8782 5.00822 9.35859V10.8192C4.25961 10.8483 3.73276 10.9609 3.28626 11.3962L3.27584 11.4066C2.68754 12.0019 2.6875 12.7538 2.6875 14V16.3208C2.6875 17.5681 2.68754 18.3201 3.27584 18.9142L3.28626 18.9246ZM5.87849 12.5496C5.32152 12.5496 4.6311 12.5496 4.51042 12.6355C4.42804 12.7701 4.42804 13.4233 4.42804 13.9999V16.3208C4.42804 16.8974 4.42804 17.5496 4.51042 17.6853C4.6311 17.7712 5.32152 17.7712 5.87849 17.7712C6.43546 17.7712 7.12588 17.7712 7.24656 17.6853C7.32894 17.5507 7.32894 16.8975 7.32894 16.3208V14C7.32894 13.4234 7.32894 12.7712 7.24656 12.6355C7.12588 12.5496 6.43546 12.5496 5.87849 12.5496Z",
    fill: "url(#paint5_linear_5178_10910)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5178_10910",
    x1: 14.0018,
    y1: 5.87756,
    x2: 14.0018,
    y2: 20.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5178_10910",
    x1: 14.0018,
    y1: 5.87756,
    x2: 14.0018,
    y2: 20.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5178_10910",
    x1: 14.0018,
    y1: 5.87756,
    x2: 14.0018,
    y2: 20.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5178_10910",
    x1: 14.001,
    y1: 2.68652,
    x2: 14.001,
    y2: 25.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5178_10910",
    x1: 14.001,
    y1: 2.68652,
    x2: 14.001,
    y2: 25.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5178_10910",
    x1: 14.001,
    y1: 2.68652,
    x2: 14.001,
    y2: 25.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketAnalysis);
export default __webpack_public_path__ + "static/media/market-analysis.689d90bb3ab41481d74dd9ee114e81dd.svg";
export { ForwardRef as ReactComponent };